const newsletter = (): void => {
  const entity = window.aguadecoco.helpers.vtexMasterdata({
    entity_sigla: 'NL',
  });

  const $form = document.querySelector('.newsletter-form');

  const fnSendNewsletter = async (e) => {
    const { target } = e;

    const formData = new FormData(target as HTMLFormElement);
    const firstName = formData.get('name');
    const email = formData.get('email');

    await entity.post({
      source: window.location.pathname,
      email,
      firstName,
    });
  };

  $form?.addEventListener('submit', (event) => {
    event.preventDefault();
    fnSendNewsletter(event);
  });
};

Object.assign(window.aguadecoco, { widgets: Object.assign(window.aguadecoco.widgets || {}, { newsletter }) });

newsletter();

export default newsletter;
